import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { NavigatorProps, ARROW_LINK_DIRECTION } from "../typings";
import { ArrowLink } from "./components/ArrowLink";
import { UitkSpacing } from "uitk-react-spacing";

export const NavigatorChart = ({ monthRange, onChange, currentSlide, shouldShowNavigation }: NavigatorProps) => (
  <UitkSpacing padding={{ blockstart: "three", blockend: "four" }}>
    <UitkLayoutFlex justifyContent={shouldShowNavigation ? "space-between" : "center"}>
      {shouldShowNavigation && (
        <UitkLayoutFlexItem>
          <div>
            <ArrowLink direction={ARROW_LINK_DIRECTION.LEFT} onClick={onChange} disabled={!currentSlide} />
          </div>
        </UitkLayoutFlexItem>
      )}
      <UitkSpacing padding={{ block: "two" }}>
        <UitkLayoutFlexItem>
          <span>{monthRange}</span>
        </UitkLayoutFlexItem>
      </UitkSpacing>
      {shouldShowNavigation && (
        <UitkLayoutFlexItem>
          <div>
            <ArrowLink direction={ARROW_LINK_DIRECTION.RIGHT} onClick={onChange} disabled={!!currentSlide} />
          </div>
        </UitkLayoutFlexItem>
      )}
    </UitkLayoutFlex>
  </UitkSpacing>
);
